module.exports = __webpack_public_path__ + "img/technology.3fceb26.jpg";